<template>
    <div>
        <current-board-member :client="client" :title="title" :type="type" @refresh-all="refreshHistoric"></current-board-member>

        <history-board-members class="mt-4" :client="client" :title="title" :type="type" :refresh-historic-members.sync="refreshHistoricMembersState" :isHistory="true"></history-board-members>
    </div>
</template>

<script>
import CurrentBoardMember from '@/components/corporate/CurrentBoardMember'
import HistoryBoardMembers from '@/components/corporate/HistoryBoardMembers'

export default {
    name: 'board-member',
    props: ['title', 'client', 'type'],
    components: {
        CurrentBoardMember,
        HistoryBoardMembers
    },
    data: function () {
        return {
            refreshHistoricMembersState: false
        }
    },
    methods: {
        refreshHistoric () {
            this.refreshHistoricMembersState = true
        }
    }
}
</script>
